import { render, staticRenderFns } from "./Brightpearl.vue?vue&type=template&id=147e4f6b"
import script from "./Brightpearl.vue?vue&type=script&lang=js"
export * from "./Brightpearl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports